import React, { CSSProperties } from 'react'
import s from './AlfakherHeading.module.scss'

type WidgetConfiguration = {
    enabled?: boolean
    widgetConfiguration: {
        'kicker-text'?: string
        'headline-text'?: string
        'subline-text'?: string
        'content-alignment'?: string
        'headline-title-tag'?: string
    }
}

const AlfakherHeading = (props: WidgetConfiguration) => {
    const { enabled, widgetConfiguration } = props

    const {
        'kicker-text': kickerText,
        'headline-text': headlineText,
        'subline-text': sublineText,
        'content-alignment': contentAlignment,
        'headline-title-tag': headlineTitleTag
    } = widgetConfiguration

    const contentPosition: CSSProperties = {
        textAlign: (contentAlignment || 'left') as CSSProperties['textAlign']
    }

    if (!enabled) {
        return <></>
    }

    return (
        <>
            {(kickerText || headlineText || sublineText) && (
                <div
                    className={s['alfakher-heading-top-section']}
                    style={contentPosition}
                >
                    {kickerText && (
                        <div className={s['alfakher-heading-kicker-text']}>
                            {kickerText}
                        </div>
                    )}
                    {headlineText &&
                        React.createElement(
                            headlineTitleTag || 'h2',
                            { className: s['alfakher-heading-headline'] },
                            headlineText
                        )}
                    {sublineText && (
                        <div className={s['alfakher-heading-subline']}>
                            {sublineText}
                        </div>
                    )}
                </div>
            )}
        </>
    )
}

export default AlfakherHeading
